import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from '#/hooks/useRootStore';
import { autorun } from 'mobx';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { AlertContainer } from './components';

const Notifier: React.FC<React.PropsWithChildren<unknown>> = observer(function NotifierComponent() {
    const rootStore = useRootStore();
    const { enqueueSnackbar } = useSnackbar();
    React.useEffect(
        () =>
            autorun(() => {
                rootStore.notificationStore.notifications.forEach((notification) => {
                    if (rootStore.notificationStore.hasDisplayed(notification)) {
                        return;
                    }
                    notification.options = { ...notification.options };
                    if (notification.options?.variant !== 'default' && !notification.options.content) {
                        notification.options.content = (
                            <AlertContainer title={notification.title} message={notification.message} variant={notification.options.variant} />
                        );
                    }
                    enqueueSnackbar(notification.message, notification.options);
                    if (notification.options.key) {
                        rootStore.notificationStore.displayedNotifications.push(notification.options.key);
                    }
                    rootStore.notificationStore.removeNotification(notification);
                });
            }),
        [enqueueSnackbar, rootStore.notificationStore]
    );

    return null;
});
Notifier.displayName = 'Notifier';
const NotificationProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
    <SnackbarProvider
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        maxSnack={3}
    >
        <Notifier />
        {children}
    </SnackbarProvider>
);
export default NotificationProvider;
